<template>
  <div
    ref="root"
    :class="{
      'slo-editable-text': true,
      'focus-within': focusWithin,
      placeholder: !value,
    }"
  >
    <input
      ref="input"
      type="text"
      v-bind="$attrs"
      :value="value"
      :placeholder="placeholder"
      @keydown="handleKeydown($event)"
      @input.stop="handleInput"
      @focus="focusWithin = true"
      @blur="handleBlur($event)"
    />
    <span aria-hidden="true">{{ value || placeholder }}</span>
  </div>
</template>

<script>
export default {
  name: 'SloEditableText',
  data() {
    return {
      focusWithin: false
    };
  },
  mounted() {
    if (this.autofocus) {
      this.setFocus();
    }
  },
  props: {
    autofocus: {type: Boolean, default: false},
    value: {type: [String, Number, Boolean], default: null},
    placeholder: {type: String, default: ''}
  },
  methods: {
    handleKeydown($event) {
      if ($event.key === 'Enter') {
        this.$emit('enter', $event);
      }
    },
    blur() {
      this.$nextTick(() => {
        this.$refs.input.blur();
      });
    },
    setFocus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
        this.$refs.input.setSelectionRange(0, this.$refs.input.value.length, 'none');
      });
    },
    handleInput(event) {
      this.$emit('input', event.target.value);
    },
    handleBlur(event) {
      this.focusWithin = false;
      this.$emit('blur', event);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/system';

.slo-editable-text {
  position: relative;
  display: inline-flex;
  padding: 0 0.25em;
  margin: 0 -0.25em;
  font: inherit;
  font-size: inherit;
  text-transform: inherit;

  > input {
    position: absolute;
    top: 0;
    left: 0;
    right: -2em;
    bottom: 0;
    height: 1em;
    line-height: 1;
    width: calc(100% + 2em);
    letter-spacing: initial !important;
    font-size: inherit;
    padding: 0 0.25em;
    margin: 0 -0.125em;
    border: none;
  }

  > span {
    height: 1em;
    pointer-events: none;
    width: auto;
    flex: 1 0 auto;
    line-height: 1;
    opacity: 0;
    color: transparent;
    letter-spacing: initial !important;
    padding: 0 0.25em;
    margin: 0 -0.125em;
    border: none;
    white-space: pre;
  }

  &::after {
    content: '';
    position: absolute;
    right: 0.5em;
    bottom: -3px;
    left: 0;
    height: 1px;
    background-color: $color-gray-400;
    opacity: 0;
    transform: translateY(2px);
    transition: 100ms ease-out;
    transition-property: opacity, transform;
  }

  &:hover,
  &.focus-within,
  &:active {
    &::after {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &.focus-within,
  &:active {
    &::after {
      background-color: $color-blue-400;
    }
  }
}
</style>
